import React from 'react'
import * as S from './styles'

import { useTranslation } from 'react-i18next'

const CustomCompleteAnatomy = () => {
  const { t } = useTranslation()

  return (
    <S.CustomCompleteAnatomyContainer>
      <p>{t('subtitles.completeAnatomy3')}</p>
      <div>
        <h4>{t('titles.atlas3D')}</h4>
        <p>{t('subtitles.completeAnatomy4')}</p>
      </div>
      <div>
        <h4>{t('titles.cadaver3D')}</h4>
        <p>{t('subtitles.completeAnatomy5')}</p>
      </div>
    </S.CustomCompleteAnatomyContainer>
  )
}

export default CustomCompleteAnatomy
